
export const SET_TRIPS = 'SET_TRIPS'
export const SET_INVITE_TRIP = 'SET_INVITE_TRIP'
export const SET_CURRENT_CREW_FILE = 'SET_CURRENT_CREW_FILE'
export const SET_TRIP_INVITATIONS = 'SET_TRIP_INVITATIONS'
export const SET_EXPERIENCE = 'SET_EXPERIENCE'

export const SET_IS_MORE_TRIPS = 'SET_IS_MORE_TRIPS'
